import { styled } from 'baseui'

export const Card = styled<'article', { $isLate: boolean }>('article', ({ $theme, $isLate }) => ({
  flexShrink: 0,
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '0.75rem',
  minHeight: '3.5rem',
  boxSizing: 'border-box',
  padding: '0.5rem 0.5rem 0.5rem 0.75rem',
  backgroundColor: $theme.colors.white,
  border: `1px solid ${$isLate ? $theme.colors.negative200 : $theme.colors.borderPulseCard}`,
  borderLeft: `0.25rem solid ${$isLate ? $theme.colors.negative : $theme.colors.warning}`,
  borderRadius: $theme.borders.radius300,
  boxShadow: $theme.lighting.shadow600,
}))

export const IconBubble = styled<'span', { $isLate: boolean }>('span', ({ $theme, $isLate }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '2rem',
  height: '2rem',
  borderRadius: '50%',
  backgroundColor: $isLate ? $theme.colors.negative50 : $theme.colors.warningBg,
  color: $isLate ? $theme.colors.negative : $theme.colors.warning,
}))

export const TextBlock = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
})

export const CardTitle = styled<'h3', { $isLate: boolean }>('h3', ({ $theme, $isLate }) => ({
  margin: 0,
  fontSize: '0.875rem',
  lineHeight: '1.125rem',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  color: $isLate ? $theme.colors.negative : $theme.colors.textHeading,
}))

export const CardSubtitle = styled('p', ({ $theme }) => ({
  margin: 0,
  fontSize: '0.75rem',
  lineHeight: '1rem',
  whiteSpace: 'nowrap',
  color: $theme.colors.warningText,
}))

export const Divider = styled('span', ({ $theme }) => ({
  flexShrink: 0,
  width: '1px',
  height: '2rem',
  backgroundColor: $theme.colors.borderPulseCard,
}))

export const CustomerName = styled('p', ({ $theme }) => ({
  margin: 0,
  fontSize: '0.875rem',
  lineHeight: '1.125rem',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  color: $theme.colors.textHeading,
}))

export const CustomerPhone = styled('p', ({ $theme }) => ({
  margin: 0,
  fontSize: '0.75rem',
  lineHeight: '1rem',
  whiteSpace: 'nowrap',
  color: $theme.colors.textMuted,
}))

export const StatusAndActions = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  marginLeft: 'auto',
})

export const CallStatus = styled<'p', { $failed: boolean }>('p', ({ $theme, $failed }) => ({
  margin: 0,
  maxWidth: '14rem',
  fontSize: '0.8125rem',
  lineHeight: '1rem',
  color: $failed ? $theme.colors.negative600 : $theme.colors.textMuted,
}))

export const Actions = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  flexShrink: 0,
})

export const CloseButton = styled('button', ({ $theme }) => ({
  display: 'inline-flex',
  flexShrink: 0,
  padding: '0.25rem',
  border: 'none',
  backgroundColor: 'transparent',
  color: $theme.colors.textMuted,
  cursor: 'pointer',
  ':disabled': {
    cursor: 'not-allowed',
  },
}))
